import { Component, OnInit } from "@angular/core";
import * as Highcharts from "highcharts";
import { first } from "rxjs/operators";
import { NewDashboardCorporateService } from "src/app/new-dashboard/core/service/new-dashboard-corporate.service";
//import { DashboardDossierModel } from "src/app/new-dashboard/core/model/quantite_by_workflow/DashboardDossierModel";
import { DashboardDossierModel } from "src/app/new-dashboard/core/model/DashboardDossierModel";
import { QuantiteDossierPortefeuilleParProduitDTO } from "src/app/new-dashboard/core/model/quantite-dossier-portefeuille-par-produit-dto";
import { DashboardAllMarcheService } from "src/app/new-dashboard/core/service/dashboard-all-marche.service";
import { DashboardDossierNombre } from "src/app/new-dashboard/core/model/DashboardDossierNombre";
import { DashboardDossierStatut } from "src/app/new-dashboard/core/model/DashboardDossierStatut";
import { KeycloakService } from "src/app/core/services/auth/keycloak.service";
import { ChartViewDTO } from 'src/app/new-dashboard/core/model/chart_view/chart-view-dto';
import { NewDashboardProfessionnelService } from 'src/app/new-dashboard/core/service/new-dashboard-professionnel.service';
import { QuantiteDossierByPeriodeDTO } from 'src/app/new-dashboard/core/model/quantite-dossier-by-periode-dto';
import { QuantiteDossierPortefeuilleParSecteurDTO } from 'src/app/new-dashboard/core/model/quantite-dossier-portefeuille-par-secteur-dto.1';
import { TotalQuantiteMontantPourcentage } from 'src/app/new-dashboard/core/model/quantite_montant_pourcentage/total-quantite-montant-pourcentage';

export const compare = (v1, v2) => v1 < v2 ? -1 : v1 > v2 ? 1 : 0;
import { NgbdSortableHeader } from 'src/app/shared/directives/sortable.directive';
import { SortEvent } from 'src/app/shared/directives/sort-event.interface';

@Component({
  selector: "app-production",
  templateUrl: "./production.component.html",
  styleUrls: ["./production.component.scss"]
})
export class ProductionComponent implements OnInit {
  dossiersByProfils: DashboardDossierStatut[];
  dataSource: DashboardDossierModel[];
  dossiersTimePeriod: DashboardDossierNombre;
  cumulParStatut: any[];
  username: string;
  highcharts = Highcharts;
  updateFlag = false;
  chartOptions: any;
  chartOptionsMnt: any;
  totalCumulNombres: number = 0;
  totalCumulMontants: number = 0;

  quantiteDossierPortefeuilleParProduitDTOs: QuantiteDossierPortefeuilleParProduitDTO[];
  quantiteDossierPortefeuilleParSecteurDTOs: QuantiteDossierPortefeuilleParSecteurDTO[];

  quantiteByPeriode: ChartViewDTO;
  montantByPeriode: ChartViewDTO;

  chartOptionsQuantiteByPeriode: any;
  chartOptionsMontantByPeriode: any;

  quantiteDossierByPeriodeDTO: QuantiteDossierByPeriodeDTO;

  totalQuantiteMontantPourcentage : TotalQuantiteMontantPourcentage;

  sortRepartition :SortEvent = {column:'quantite',direction:'desc'};
  sortDossierProduit :SortEvent = {column:'montantEnCours',direction:'desc'};
  sortDossierSecteur :SortEvent = {column:'montantEnCours',direction:'desc'};

  constructor(
    private corporateService: NewDashboardCorporateService,
    private _dashboardAllMarcheService: DashboardAllMarcheService,
    private _keycloakService: KeycloakService //_newDashboardProfessionnelService : NewDashboardCorporateService
  ) {
    this.username = _keycloakService.getUsername();
  }

  ngOnInit() {
    //this.getDashboardCorpoateProduction();
    this.getDossiersByStatutAndProfil();
    this.quantiteDossierByPeriodeAndAgence();
    this.quantiteDossierPortefeuilleParProduit("_");
    this.quantiteDossierPortefeuilleParSecteur("_");

    this.quantiteDossierStatutSurLes6DerniersMois("_");
    this.montantDossierStatutSurLes6DerniersMois("_");
    this.repartitionDossier12DerniersMoisParStatus();
  }

  /*getTotalDossierByTimePeriod() {
    this.corporateService
      .getTotalDossierByTimePeriod("CORPORATE")
      .subscribe((data) => {
        this.dossiersTimePeriod = data;
      });
  }*/

  
  onSortRepartition({column, direction}: SortEvent) {
    debugger
    this.sortRepartition.column = column
    this.sortRepartition.direction = direction

    // sorting
    if (direction === '') {
      this.totalQuantiteMontantPourcentage.quantiteMontantPourcentageList;
    } 
    else {
      
      this.totalQuantiteMontantPourcentage.quantiteMontantPourcentageList = [...this.totalQuantiteMontantPourcentage.quantiteMontantPourcentageList].sort((a, b) => {
        const res = compare(a[column], b[column]);
        return direction === 'asc' ? res : -res;
      });
    }
  }


  onSortDossierProduit({column, direction}: SortEvent) {
    debugger
    this.sortDossierProduit.column = column
    this.sortDossierProduit.direction = direction

    // sorting
    if (direction === '') {
      this.quantiteDossierPortefeuilleParProduitDTOs;
    } 
    else {
      
      this.quantiteDossierPortefeuilleParProduitDTOs = [...this.quantiteDossierPortefeuilleParProduitDTOs].sort((a, b) => {
        const res = compare(a[column], b[column]);
        return direction === 'asc' ? res : -res;
      });
    }
  }

  
  onSortDossierSecteur({column, direction}: SortEvent) {
    debugger
    this.sortDossierSecteur.column = column
    this.sortDossierSecteur.direction = direction

    // sorting
    if (direction === '') {
      this.quantiteDossierPortefeuilleParSecteurDTOs;
    } 
    else {
      
      this.quantiteDossierPortefeuilleParSecteurDTOs = [...this.quantiteDossierPortefeuilleParSecteurDTOs].sort((a, b) => {
        const res = compare(a[column], b[column]);
        return direction === 'asc' ? res : -res;
      });
    }
  }
    


  quantiteDossierByPeriodeAndAgence() {
    this.corporateService
      .quantiteDossierByPeriodeAndAgence("_")
      .pipe(first())
      .subscribe(
        data => {
          this.quantiteDossierByPeriodeDTO = data;
        },
        error => {
          console.log(error);
        }
      );
  }
  getDossiersByStatutAndProfil() {
    this.corporateService.getDossiersByStatutAndProfil().subscribe(data => {
      console.log(data);
      this.dossiersByProfils = data;
    });
  }

  /*
  getDashboardCorpoateProduction() {
    this.corporateService.getDashboardCorpoateProduction().subscribe(
      data => {
        this.dataSource = data;
        const categories = [...new Set(data.map(item => item.dateMonthYear))];
        const series = this.getSeriesByStatut(data);
        this.updateFlag = true;
        this.chartOptions = {
          chart: {
            type: "column"
          },
          title: {
            text: "Volume de dossiers par statut des 12 derniers mois"
          },
          xAxis: {
            categories: categories
          },
          yAxis: {
            title: {
              text: "Volume"
            }
          },
          series: series[0]
        };

        this.chartOptionsMnt = {
          chart: {
            type: "spline"
          },
          title: {
            text: "Montant par statut des 12 derniers mois"
          },
          xAxis: {
            categories: categories
          },
          yAxis: {
            title: {
              text: "Montant(XOF)"
            }
          },
          tooltip: {
            valueSuffix: " XOF"
          },
          series: series[1]
        };
        this.updateFlag = true;
        this.cumulParStatut = this.getCumulParStatut(data);
        this.totalCumulNombres = this.getTotalCumulNombres(this.cumulParStatut);
        this.totalCumulMontants = this.getTotalCumulMontants(
          this.cumulParStatut
        );
      },
      error => {
        console.log("error", error);
      }
    );
  }

  getSeriesByStatut(data: any[]): any[] {
    const statuts = [...new Set(data.map(item => item.statutDossier))];
    const nombreSeries = [];
    const montantSeries = [];

    statuts.forEach(statut => {
      const serieNombreData = data
        .filter(item => item.statutDossier === statut)
        .map(item => item.nombreDossier);
      nombreSeries.push({ name: statut, data: serieNombreData });

      const serieMontantData = data
        .filter(item => item.statutDossier === statut)
        .map(item => item.montantDossier);
      montantSeries.push({ name: statut, data: serieMontantData });
    });

    return [nombreSeries, montantSeries];
  }

  getCumulParStatut(data: any[]): any[] {
    const statuts = [...new Set(data.map(item => item.statutDossier))];
    const cumulParStatut = [];

    statuts.forEach(statut => {
      const statutData = data.filter(item => item.statutDossier === statut);
      const cumulNombres = statutData.reduce(
        (acc, item) => acc + item.nombreDossier,
        0
      );
      const cumulMontants = statutData.reduce(
        (acc, item) => acc + item.montantDossier,
        0
      );

      cumulParStatut.push({
        statutDossier: statut,
        cumulNombres: cumulNombres,
        cumulMontants: cumulMontants
      });
    });

    return cumulParStatut;
  }

  getTotalCumulNombres(cumulParStatut: any[]): number {
    return cumulParStatut.reduce((acc, item) => acc + item.cumulNombres, 0);
  }
  getTotalCumulMontants(cumulParStatut: any[]): number {
    return cumulParStatut.reduce((acc, item) => acc + item.cumulMontants, 0);
  }
  */

  quantiteDossierPortefeuilleParProduit(codeAgence) {
    this._dashboardAllMarcheService
      .quantiteDossierPortefeuilleParProduit("CORPORATE", codeAgence)
      .pipe(first())
      .subscribe(
        response => {
          this.quantiteDossierPortefeuilleParProduitDTOs = response;
        },
        error => {
          console.log(error);
        }
      );
  }
  
  quantiteDossierPortefeuilleParSecteur(codeAgence) {
    this._dashboardAllMarcheService
      .quantiteDossierPortefeuilleParSecteur("CORPORATE", codeAgence)
      .pipe(first())
      .subscribe(
        response => {
          this.quantiteDossierPortefeuilleParSecteurDTOs = response;
        },
        error => {
          console.log(error);
        }
      );
  }

  //

  /*quantiteDossierStatutSurLes6DerniersMois(codeAgence) {
    this.corporateService
      .quantiteDossierStatutSurLes6DerniersMois(codeAgence)
      .pipe(first())
      .subscribe(
        response => {
          this.quantiteByPeriode = response;

          this.chartOptionsQuantiteByPeriode = {
            chart: {
              type: "spline"
            },
            title: {
              text: "Quantité de dossier sur les 6 derniers mois"
            },
            subtitle: {
              text: null
            },
            xAxis: {
              categories: this.quantiteByPeriode.categories
            },
            yAxis: {
              title: {
                text: "Qté"
              }
            },
            tooltip: {
              valueSuffix: null
            },

            legend: {
              layout: "vertical",
              align: "right",
              verticalAlign: "top",
              x: 0,
              y: 100,
              floating: false,
              borderWidth: 1,

              backgroundColor: "#FFFFFF",
              shadow: true
            },

            series: this.quantiteByPeriode.series
          };
        },
        error => {
          console.log(error);
        }
      );
  }

  montantDossierStatutSurLes6DerniersMois(codeAgence) {
    this.corporateService
      .montantDossierStatutSurLes6DerniersMois(codeAgence)
      .pipe(first())
      .subscribe(
        response => {
          this.montantByPeriode = response;

          this.chartOptionsMontantByPeriode = {
            chart: {
              type: "spline"
            },
            title: {
              text: "Montant de dossier sur les 6 derniers mois"
            },
            subtitle: {
              text: null
            },
            xAxis: {
              categories: this.montantByPeriode.categories
            },
            yAxis: {
              title: {
                text: "Qté"
              }
            },
            tooltip: {
              valueSuffix: null
            },

            legend: {
              layout: "vertical",
              align: "right",
              verticalAlign: "top",
              x: 0,
              y: 100,
              floating: false,
              borderWidth: 1,

              backgroundColor: "#FFFFFF",
              shadow: true
            },

            series: this.montantByPeriode.series
          };
        },
        error => {
          console.log(error);
        }
      );
  }*/



  quantiteDossierStatutSurLes6DerniersMois(codeAgence) {
    this.corporateService
      .quantiteDossierStatutSurLes6DerniersMois(codeAgence)
      .pipe(first())
      .subscribe(
        response => {
          this.quantiteByPeriode = response;

          this.chartOptionsQuantiteByPeriode = {
            chart: {
              type: "column" // Changer le type en "column"
            },
            title: {
              text: "Quantité de dossier sur les 6 derniers mois"
            },
            subtitle: {
              text: null
            },
            xAxis: {
              categories: this.quantiteByPeriode.categories
            },
            yAxis: {
              title: {
                text: "Qté"
              }
            },
            tooltip: {
              valueSuffix: null
            },

            legend: {
              layout: "vertical",
              align: "right",
              verticalAlign: "top",
              x: 0,
              y: 100,
              floating: false,
              borderWidth: 1,

              backgroundColor: "#FFFFFF",
              shadow: true
            },

            plotOptions: {
              column: {
                stacking: "normal", // Ajouter cette ligne pour empiler les colonnes
                dataLabels: {
                  enabled: true
                }
              }
            },

            series: this.quantiteByPeriode.series
          };
        },
        error => {
          console.log(error);
        }
      );
  }

  montantDossierStatutSurLes6DerniersMois(codeAgence) {
    this.corporateService
      .montantDossierStatutSurLes6DerniersMois(codeAgence)
      .pipe(first())
      .subscribe(
        response => {
          this.montantByPeriode = response;

          this.chartOptionsMontantByPeriode = {
            chart: {
              type: "column" // Changer le type en "column"
            },
            title: {
              text: "Montant de dossier sur les 6 derniers mois"
            },
            subtitle: {
              text: null
            },
            xAxis: {
              categories: this.montantByPeriode.categories
            },
            yAxis: {
              title: {
                text: "Montant"
              }
            },
            tooltip: {
              valueSuffix: null
            },

            legend: {
              layout: "vertical",
              align: "right",
              verticalAlign: "top",
              x: 0,
              y: 100,
              floating: false,
              borderWidth: 1,

              backgroundColor: "#FFFFFF",
              shadow: true
            },

            plotOptions: {
              column: {
                stacking: "normal", // Ajouter cette ligne pour empiler les colonnes
                dataLabels: {
                  enabled: true
                }
              }
            },

            series: this.montantByPeriode.series
          };
        },
        error => {
          console.log(error);
        }
      );
  }






  repartitionDossier12DerniersMoisParStatus() {
    this._dashboardAllMarcheService
      .repartitionDossier12DerniersMoisParStatus("CORPORATE")
      .pipe(first())
      .subscribe(
        response => {
          this.totalQuantiteMontantPourcentage = response;
        },
        error => {
          console.log(error);
        }
      );
  }



  //
}
